import common from '@/api/common'
import rules from './rules'

export default {
  data () {
    return {
      formRules: {
        phone: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!rules.phone(value)) {
              callback(new Error('请输入正确的手机号'))
            } else {
              if (this.formRules.phonePass === value) {
                callback()
              } else {
                common.checkPhone(value, this.formRules.userUuid).then(res => {
                  if (res) {
                    this.formRules.phonePass = value
                    callback()
                  } else {
                    callback(new Error('该手机号已经被注册'))
                  }
                })
              }
            }
          },
          trigger: 'blur'
        }],
        idNumber: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!rules.idNumber(value)) {
              callback(new Error('请输入正确的证件号码'))
            } else {
              // 避免验证所有表单时，重复请求
              if (this.formRules.idNumberPass === value) {
                callback()
              } else {
                common.checkIdNumber(value, this.formRules.userUuid).then(res => {
                  if (res) {
                    this.formRules.idNumberPass = value
                    callback()
                  } else {
                    callback(new Error('该身份证号已经被注册'))
                  }
                })
              }
            }
          },
          trigger: 'blur'
        }],
        idName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('请输入领队姓名'))
            }
          },
          trigger: 'blur' }],
        youthUuid: [{ required: true, message: '请选择当前培训机构', trigger: 'change' }],
        organUuid: [{ required: true, message: '请选择当前培训协会', trigger: 'change' }],
        password: [{ required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              if (!rules.password(value)) {
                callback(new Error(this.$t('passwordLimit')))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        confirmPassword: [{ required: false,
          validator: (rule, value, callback) => {
            if (value) {
              if (this.leaderInfo.password) {
                if (value === this.leaderInfo.password) {
                  callback()
                } else {
                  callback(new Error('两次密码不一致'))
                }
              } else {
                if (!rules.password(value)) {
                  callback(new Error(this.$t('passwordLimit')))
                } else {
                  callback()
                }
              }
            } else {
              if (this.leaderInfo.password) {
                callback(new Error('两次密码不一致'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        squadUuid: [{ required: false,
          validator: (rule, value, callback) => {
            callback()
            // if (value) {
            //   callback()
            // } else {
            //   callback(new Error('请选择球队'))
            // }
          },
          trigger: 'change' }],
      }
    }
  }
}
